<template>
  <div class="wrapper">
    <div class="d-flex flex-wrap menu-wrapper">
      <div
        class="menu d-flex flex-column align-center pa-3 mt-4"
        v-for="m in visibleMenus"
        :key="m.type"
        @click="clickMenu(m)"
      >
        <v-badge
          v-if="m.type === 'invoice'"
          :model-value="noneRead"
          color="red"
          offset-x="30"
          offset-y="8"
          overlap
          small
        >
          <v-img
            class="mb-2"
            width="120"
            height="120"
            :src="m.img ?? undefined"
            contain
          ></v-img>
        </v-badge>

        <v-img
          v-else
          class="mb-2"
          width="120"
          height="140"
          :src="m.img ?? undefined"
          contain
        ></v-img>
        <div v-if="m.locale !== 'ja'" class="menu-title">{{ m.title }}</div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from 'vue';
import { when } from '@/service/Switch';
import { familyModule } from '@/store/entityModules/family';
import { invoiceModule } from '@/store/entityModules/invoice';
import { SHOW_INVOICE_UI } from '@/constants/invoiceUi';
import { locale, t } from '@/i18n';

enum MenuType {
  CHILDREN = 'children',
  PARENTINFO = 'parentinfo',
  REFERENCES = 'references',
  GROWTH = 'growth',
  INVOICE = 'invoice',
  SETTING = 'setting',
  INQUIRY = 'inquiry',
  HELP = 'help',
  // LOGOUT = 'logout',
}

interface Menu {
  type: MenuType;
  img: string;
  title: string;
  path: string;
  locale: string;
}

interface DataType {
  noneRead: boolean;
  menus: Menu[];
}

export default defineComponent({

  data: (): DataType => ({
    noneRead: false,
    menus: [
      // {
      //   type: MenuType.CHILDREN,
      //   img: require('@/assets/children.png'),
      //   title: '児童票',
      //   path: '/children',
      // },
      // {
      //   type: MenuType.PARENTINFO,
      //   img: require('@/assets/parent.png'),
      //   title: '保護者票',
      //   path: '/parent/info',
      // },
      // {
      //   type: MenuType.REFERENCES,
      //   img: require('@/assets/parent.png'),
      //   title: '資料室',
      //   path: '/references',
      // },
      {
        type: MenuType.GROWTH,
        img: locale === 'ja'
          ? require('@/assets/growth.png')
          : require('@/assets/growth.icon.png'),
        title: t('setting.growth'),
        path: '/growth/select',
        locale: locale,
      },
      {
        type: MenuType.INVOICE,
        img: require('@/assets/invoice.png'),
        title: t('setting.invoice'),
        path: '/invoice/select',
        locale: locale,
      },
      {
        type: MenuType.SETTING,
        img: locale === 'ja'
          ? require('@/assets/cog.png')
          : require('@/assets/cog.icon.png'),
        title: t('setting.variousSettings'),
        path: '/setting/various',
        locale: locale,
      },
      // {
      //   type: MenuType.INQUIRY,
      //   img: 'https://via.placeholder.com/240x180?text=Sample+Image+1',
      //   title: 'お問い合わせ',
      //   path: '/inquiry',
      // },
      // {
      //   type: MenuType.HELP,
      //   img: 'https://via.placeholder.com/240x180?text=Sample+Image+1',
      //   title: 'ヘルプ',
      //   path: '/help',
      // },
      // {
      //   type: MenuType.LOGOUT,
      //   img: 'https://via.placeholder.com/240x180?text=Sample+Image+1',
      //   title: 'ログアウト',
      //   path: '/children',
      // },
    ],
  }),

  computed: {
    family() {
      return familyModule.family || null;
    },
    visibleMenus(): Menu[] {
      if (SHOW_INVOICE_UI) {
        return this.menus;
      }
      return this.menus.filter((m) => m.type !== MenuType.INVOICE);
    },
  },

  methods: {
    clickMenu(menu: Menu) {
      this.$router.push(menu.path);
    },
  },
  async mounted() {
    this.noneRead = false;
    if (!SHOW_INVOICE_UI) {
      return;
    }
    if (this.family) {
      const familyChildren = this.family.children;
      const invoicesLocal = invoiceModule.invoices;
      for (var i = 0; i < familyChildren.length; i++) {
        if (typeof familyChildren[i].childId === 'number') {
          const childId = familyChildren[i].childId;
          await invoiceModule.fetchInvoices({ childId: childId, year: null });
        }
        if (typeof familyChildren[i].childId === 'string') {
          const childId = Number(familyChildren[i].childId);
          await invoiceModule.fetchInvoices({ childId: childId, year: null });
        }
        if (invoiceModule.invoices) {
          for (var j = 0; j < invoiceModule.invoices.length; j++) {
            if (!invoiceModule.invoices[j].readDate) {
              this.noneRead = true;
              break;
            }
          }
          if (this.noneRead) {
            break;
          }
        }
      }
    }
  },
});
</script>
<style lang="scss" scoped>
.wrapper {
  @supports (bottom: env(safe-area-inset-bottom)) {
    padding-top: env(safe-area-inset-top);
  }

  .menu-wrapper {
    width: 100%;

    .menu {
      width: 50%;
    }
  }
}

.menu-title {
  font-size: 20px;
  text-transform: uppercase;
  text-align: center;
}
</style>
